import type { Routes } from '../views/Routes';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import StyledText from '../components/StyledText';

type Props = NativeStackScreenProps<Routes, 'QrcodeScannerPage'>;
export default function QrcodeScannerPage({ navigation, route }: Props) {
    return (<StyledText>Not available</StyledText>)
}
